(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faigys-store"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faigys-store-map')) {
    class FaigysStoreMap extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const canvas = this.querySelector('[data-map-canvas]');
        if (!details || !summary || !canvas) return;
        let activated = false;
        summary.addEventListener('click', () => { activated = true; }, { signal: this.controller.signal });
        details.addEventListener('toggle', () => {
          if (!activated || !details.open || canvas.querySelector('iframe')) return;
          const address = this.dataset.mapAddress;
          if (!address) return;
          const mapUrl = new URL('https://www.google.com/maps');
          mapUrl.searchParams.set('q', address);
          mapUrl.searchParams.set('output', 'embed');
          const frame = document.createElement('iframe');
          frame.title = this.dataset.mapTitle || address;
          frame.loading = 'lazy';
          frame.referrerPolicy = 'no-referrer';
          frame.allowFullscreen = true;
          frame.src = mapUrl.toString();
          canvas.append(frame);
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    }
    customElements.define('faigys-store-map', FaigysStoreMap);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
